import { UseQueryResult } from "react-query";

export const isReadyWithData = (response: UseQueryResult) => {
  return (
    response.status === "success" &&
    response.data !== undefined &&
    response.data !== null
  );
};
